import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, SimpleChange, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { MatProgressBarModule, ProgressBarMode } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'lib-overlay-loading',
  templateUrl: './overlay-loading.component.html',
  styleUrls: ['./overlay-loading.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatProgressBarModule
  ]
})
export class OverlayLoadingComponent implements OnInit {

  @Input() isShowSpinner: boolean = false;
  @Input() showProgress:boolean;
  @Input() message:string;
  @Input() isLoading:boolean;

  @Input() progressTotal:number;
  @Input() progressNumber:number;
  @Input() isProgressInPercentage: boolean = false;
  @Input() progressMode:ProgressBarMode="determinate";
  @Input() fullscreen: boolean = true;
  
  progressPercent:number;
  isViewInit:boolean;

  constructor( public viewContainerRef: ViewContainerRef,
    public overlay: Overlay) { 
      this.isViewInit=false;
    }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.isViewInit=true;
    if (this.isLoading) this.openSelectedListView(this.fullscreen); 
      else this.closeSelectedListView();
  }

  ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
    if (changes["progressNumber"]) {
      this.progressPercent=(this.progressNumber*100)/this.progressTotal;
      if (this.progressNumber==this.progressTotal) this.closeSelectedListView();
    }

    if (changes["isLoading"]) {
      if (this.isLoading) this.openSelectedListView(this.fullscreen); 
      else this.closeSelectedListView();
    }
  }

  ngOnDestroy() {
    this.closeSelectedListView();
  }


   /**
   * Overlay per visualizzare il caricamento delle analisi in modo asincrono
   */
  //#Region "Overlay"
  @ViewChild("loadingView") LoadingView: TemplateRef<any>;
  overlayref:OverlayRef;
  openSelectedListView(modal:boolean=false) {
    if (this.overlayref||!this.isViewInit) return;
    let strategy = this.overlay.position().global().right().bottom();
    if (modal) {
      strategy = this.overlay.position().global().centerHorizontally().centerVertically();
    }
    let config = new OverlayConfig({positionStrategy: strategy,disposeOnNavigation:true});
    if (modal) config.hasBackdrop = true;
    this.overlayref = this.overlay.create(config);
    
    this.overlayref.attach(new TemplatePortal(this.LoadingView, this.viewContainerRef));
  }

  closeSelectedListView() {
    if (this.overlayref) {
      this.overlayref.detach();
      this.overlayref.dispose();
      this.overlayref=null;
    }
  }
  //#EndRegion "Overlay"

}
